import React, { createContext, useContext } from 'react';
import SocialResumeDetail from '../nodes/personalCenter/resumeDetail/store/socialResumeDetail';
import CampusResumeDetail from '../nodes/personalCenter/resumeDetail/store/campusResumeDetail';
import CampusResumeFormRefStore from '../nodes/personalCenter/resumeDetail/store/campusResumeFormRefStore';
import SocialResumeFormRefStore from '../nodes/personalCenter/resumeDetail/store/socialResumeFormRefStore';
import { HomeStore } from './home';
import { HeaderStore } from './header';
import { LoginStore } from './login';
import User from './user';
import Position from './position';
import Delivery from './delivery';
import CmsData from './cms';

class StoreInit {
  homeStore;

  loginStore;

  socialResumeDetail;

  campusResumeDetail;

  campusResumeFormRefStore;

  socialResumeFormRefStore;

  user;

  position;

  delivery;

  headerStore;

  cmsData: CmsData;

  constructor() {
    this.homeStore = HomeStore;
    this.loginStore = LoginStore;
    this.headerStore = HeaderStore;
    this.socialResumeDetail = new SocialResumeDetail();
    this.campusResumeDetail = new CampusResumeDetail();
    this.campusResumeFormRefStore = new CampusResumeFormRefStore();
    this.socialResumeFormRefStore = new SocialResumeFormRefStore();
    this.user = new User();
    this.position = new Position();
    this.delivery = new Delivery();
    this.cmsData = new CmsData();
  }
}
const RootStore = new StoreInit();

const RootStoreContext = createContext(RootStore);
const RootStoreProvider = ({ rootStore, children }) => {
  const { ...storeList } = rootStore;
  return <RootStoreContext.Provider value={storeList}>{children}</RootStoreContext.Provider>;
};

const useRootStore = () => {
  return useContext(RootStoreContext);
};

export { RootStore, RootStoreProvider, useRootStore };
